module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Radiobutton_unselected_Light Blue.359c1e41.svg";